import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "/maps/argentina-provinces.geojson";

const REGIONS = [
    { code: "Buenos Aires", name: "Buenos Aires" },
    { code: "Catamarca", name: "Catamarca" },
    { code: "Chaco", name: "Chaco" },
    { code: "Chubut", name: "Chubut" },
    { code: "Ciudad de Buenos Aires", name: "Ciudad de Buenos Aires" },
    { code: "Corrientes", name: "Corrientes" },
    { code: "Córdoba", name: "Córdoba" },
    { code: "Entre Ríos", name: "Entre Ríos" },
    { code: "Formosa", name: "Formosa" },
    { code: "Jujuy", name: "Jujuy" },
    { code: "La Pampa", name: "La Pampa" },
    { code: "La Rioja", name: "La Rioja" },
    { code: "Mendoza", name: "Mendoza" },
    { code: "Misiones", name: "Misiones" },
    { code: "Neuquén", name: "Neuquén" },
    { code: "Río Negro", name: "Río Negro" },
    { code: "Salta", name: "Salta" },
    { code: "San Juan", name: "San Juan" },
    { code: "San Luis", name: "San Luis" },
    { code: "Santa Cruz", name: "Santa Cruz" },
    { code: "Santa Fe", name: "Santa Fe" },
    { code: "Santiago del Estero", name: "Santiago del Estero" },
    { code: "Tierra del Fuego", name: "Tierra del Fuego" },
    { code: "Tucumán", name: "Tucumán" },
];

const REGION_CODES = REGIONS.map(r => r.code);
const ITEMS = REGIONS.map(r => ({ id: r.code, name: r.name }));

const ArgentinaMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{ scale: 900, center: [-65, -38] }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => REGION_CODES.includes(geo.properties.name))
                        .map((geo) => {
                            const code = geo.properties.name;
                            const isVisited = visited.includes(code);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(code)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="argentina"
            analyticsLocationType="argentina"
            trackingLabel="Argentina Map"
            storageKey="argentina_map"
            title="🇦🇷 Argentina Travel Map"
            subtitle="Click on Argentine provinces you've visited. Or use the checklist below!"
            items={ITEMS}
            noun="Provinces"
            unitLabel="provinces"
            captionUnit="Argentine provinces"
            share={{
                region: 'Argentina',
                fileName: 'visited-argentina-map.png',
                trackId: 'argentina'
            }}
            renderMap={renderMap}
        />
    );
};

export default ArgentinaMapSection;
